<template>
  <div class="h-12 lg:h-20">
    <slot></slot>
  </div>
</template>
<script setup></script>
